import { Component, Input } from '@angular/core';
import { LinkRef } from '@kion/data-models';

interface Category {
  image: {url: string, altText: string, titleText?: string};
  linkRef: LinkRef;
}

@Component({
  selector: 'kion-cms-category-list-item',
  templateUrl: './category-list-item.component.html',
  styleUrls: ['./category-list-item.component.scss']
})
export class CategoryListItemComponent {

  @Input() category: Category;

}
